import { render, staticRenderFns } from "./CourseAssign.vue?vue&type=template&id=5eccf87e&scoped=true&"
import script from "./CourseAssign.vue?vue&type=script&lang=js&"
export * from "./CourseAssign.vue?vue&type=script&lang=js&"
import style0 from "./CourseAssign.vue?vue&type=style&index=0&id=5eccf87e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eccf87e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
